import React from 'react'
import IndexContext from '../contexts/IndexContext'

export default function useIndex () {
  return React.useContext(IndexContext)
}
